var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconCategories(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5H18V18.5H8V8.5Z",
    fill: "#2D80FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.5H32V18.5H22V8.5Z",
    fill: "#2D80FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.5H18V32.5H8V22.5Z",
    fill: "#2D80FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.5H32V32.5H22V22.5Z",
    fill: "#2D80FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5C14.1046 15.5 15 14.6046 15 13.5C15 12.3954 14.1046 11.5 13 11.5C11.8954 11.5 11 12.3954 11 13.5C11 14.6046 11.8954 15.5 13 15.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11.5H25V15.5H29V11.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 27.5H16M13 24.5V30.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.5C28.6569 30.5 30 29.1569 30 27.5C30 25.8431 28.6569 24.5 27 24.5C25.3431 24.5 24 25.8431 24 27.5C24 29.1569 25.3431 30.5 27 30.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCategories);
export default __webpack_public_path__ + "static/media/menu_icon_categories.a1d9338ff6604627c88bb2b2516533d2.svg";
export { ForwardRef as ReactComponent };